<template>
  <div class="wrap">
    <div class="wrapper-stepper">
      <div class="stepper">
        <div class="stepper-progress">
          <div class="stepper-progress-bar" :style="'width:' + stepperProgress "></div>
        </div>
        <div v-for="(stepInfo, index) in steps" class="stepper-item"
             :class="{ 'current': step === index + 1, 'success': step > index  }" :key="index">
              <span>
                {{ stepInfo.title }}
              </span>
          <div class="item-counter-container">
            <div class="stepper-item-counter">
              <span class="icon-check"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { customEvent } from '../../services/customEventBus'

export default {
  name: 'checkout-progress',
  props: {
    step: Number
  },
  data () {
    return {
      steps: [
        {
          key: 'Prijava',
          title: this.$t('checkout.register')
        },
        {
          key: 'Pregled korpe',
          title: this.$t('checkout.cartInfo')
        },
        {
          key: 'Podaci i plaćanje',
          title: this.$t('checkout.paymentInfo')
        },
        {
          key: 'Potvrda',
          title: this.$t('checkout.confirmation')
        }
      ]
    }
  },
  computed: {
    stepperProgress () {
      return (100 / (this.steps.length - 1)) * (this.step - 1) + '%'
    }
  },
  created () {
    customEvent.$on('FREE_CART', isFree => {
      if (isFree) {
        this.steps = this.steps.filter(step => step.key !== 'Podaci i plaćanje')
      }
    })
  }
}
</script>

<style scoped lang="scss">
.wrap {
  background-color: $white;
  width: 100vw;
  display: flex;
  justify-content: center;
  padding-top: 20px;
  box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.3);
}

.wrapper-stepper {
  background-color: $white;
}

.item-counter-container {
  height: 24px;
}

.stepper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 300px;
  position: relative;
  z-index: 0;
  margin-bottom: 24px;

  @media (#{map-get($breakpoints, sm)}) {
    width: 600px;
  }

  @media (#{map-get($breakpoints, md)}) {
    width: 615px;
  }

  &-progress {
    position: absolute;
    background-color: $grey;
    height: 2px;
    z-index: -1;
    top: 30px;
    left: 6px;
    right: 14px;
    margin: 0 auto;

    @media (#{map-get($breakpoints, sm)}) {
      top: 35px;
      left: 11px;
      right: 23px;
    }

    &-bar {
      position: absolute;
      left: 0;
      height: 100%;
      width: 0;
      background-color: $primary;
      transition: width 500ms ease;
    }
  }
}

.stepper-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: $dark-grey;
  transition: width 500ms ease;

  &:last-child {
    width: 4rem;
  }

  span {
    font-size: 12px;
    @media (#{map-get($breakpoints, sm)}) {
      font-size: 16px;
    }
  }

  &-counter {
    height: 14px;
    width: 14px;
    display: grid;
    place-items: center;
    background-color: $white;
    border-radius: 100%;
    border: 2px solid #eeeeee;
    position: relative;
    bottom: -5px;

    .icon-check {
      &:before {
        opacity: 0;
        color: $white;
        transform: scale(0);
        font-size: 1rem;
      }
    }

    .number {
      font-size: 22px;
      transition: width 500ms ease;
    }
  }

  &-title {
    position: absolute;
    font-size: 14px;
    bottom: -24px;
  }
}

.stepper-item.success {
  span {
    color: $black;
    font-size: 12px;
    @media (#{map-get($breakpoints, sm)}) {
      font-size: 16px;
    }
  }

  .stepper-item-counter {
    height: 24px;
    width: 24px;
    transition: all 500ms ease;
    border-color: $primary;
    background-color: $primary;
    color: $primary;
    bottom: 0;
    font-weight: 600;

    .icon-check {
      &:before {
        opacity: 1;
        transform: scale(1);
      }
    }

    .number {
      opacity: 0;
    }
  }
}

.stepper-item.current {
  span {
    color: $black;
    font-size: 12px;
    @media (#{map-get($breakpoints, sm)}) {
      font-size: 16px;
    }
  }

  .stepper-item-counter {
    height: 24px;
    width: 24px;
    bottom: 0;
    border-color: $primary;
    background-color: $primary;
    color: $primary;
    font-weight: 600;
  }
}
</style>
